import actions from './actions';
import getters from './getters'
import mutations from './mutations';


const getDefaultState = () => ({
  adjustments : [],
  loadingAdjustments : null,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
